export default function NotesView() {
    return <div>Here view 1 note</div>
}
